import React from 'react';
import { useNavigate } from 'react-router-dom';

import VivahLogo from '../components/VivahLogo';

const STEPS = [
  {
    step: '1',
    icon: '📝',
    title: 'Register Free Marriage Profile',
    desc: 'Fill out comprehensive marriage details including Birth Date, Birth Time, Birth Place, and Gotra for authentic Kundali evaluation.'
  },
  {
    step: '2',
    icon: '✨',
    title: '100% Free Account Setup',
    desc: 'Registration is completely free of cost. Instant account setup with zero hidden charges.'
  },
  {
    step: '3',
    icon: '🤝',
    title: 'Personalized Match Assignment',
    desc: 'Renowned marriage consultant Laxmikant Timilsina personally evaluates profiles and assigns confidential, curated match recommendations.'
  },
  {
    step: '4',
    icon: '🎉',
    title: 'Wedding Feast & Event Decor',
    desc: 'When couples decide to marry, Sabitri Catering & Tent House (Krishna Khanal - 9867155395) manages your wedding feast & mandap decor.'
  }
];

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div className="sec-wrapper">
      {/* Unified Wedding Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div style={{ marginBottom: '1.2rem' }}>
            <span className="badge-hero-top">
              ✦ NEPAL'S TRUSTED MARRIAGE CONSULTATION AGENCY ✦
            </span>
          </div>

          <div style={{ marginBottom: '1.5rem', display: 'flex', justifyContent: 'center' }}>
            <VivahLogo size="large" />
          </div>

          <h1 className="hero-title">
            Traditional Marriage Consultation & <span className="hero-title-gradient">Authentic Matchmaking</span> in Nepal
          </h1>

          <p className="hero-subtitle">
            Connecting Nepalese families through authentic Kundali evaluation, personalized consultation, and confidential matchmaking.
          </p>

          {/* Key Intro Details Chips Grid */}
          <div className="hero-highlights-grid">
            <div className="hero-highlight-chip">
              <span className="chip-icon">👤</span>
              <div>
                <span className="chip-label">Consultant & Director</span>
                <strong className="chip-val">Laxmikant Timilsina</strong>
              </div>
            </div>

            <div className="hero-highlight-chip">
              <span className="chip-icon">📍</span>
              <div>
                <span className="chip-label">Business Location</span>
                <strong className="chip-val">Yogikuti, Butwal</strong>
              </div>
            </div>

            <div className="hero-highlight-chip">
              <span className="chip-icon">🏷️</span>
              <div>
                <span className="chip-label">Registration Fee</span>
                <strong className="chip-val">100% FREE</strong>
              </div>
            </div>

            <div className="hero-highlight-chip">
              <span className="chip-icon">📲</span>
              <div>
                <span className="chip-label">Contact & Consultation</span>
                <strong className="chip-val">9857074103</strong>
              </div>
            </div>
          </div>

          <div className="hero-cta-group">
            <button className="btn btn-secondary" onClick={() => navigate('/consultation/register')}>
              Free Profile Registration →
            </button>
            <a href="tel:9857074103" className="btn btn-tertiary">
              📞 Call Laxmikant (9857074103)
            </a>
          </div>
        </div>
      </section>

        {/* Marriage Consultation Stat Box Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: '1.5rem',
          marginBottom: '4rem'
        }}>
          <div className="stat-box">
            <div className="stat-number">1,500+</div>
            <div className="stat-label">Registered Nepalese Families</div>
          </div>
          <div className="stat-box">
            <div className="stat-number">100%</div>
            <div className="stat-label">Personalized Matchmaking</div>
          </div>
          <div className="stat-box">
            <div className="stat-number">100%</div>
            <div className="stat-label">Confidential & Verified</div>
          </div>
          <div className="stat-box">
            <div className="stat-number">FREE</div>
            <div className="stat-label">Profile Registration</div>
          </div>
        </div>

        {/* 4 Steps Registration Workflow */}
        <div style={{ marginBottom: '1rem' }}>
          <h2 className="section-title">How Marriage Consultation Works</h2>
          <p style={{ textAlign: 'center', color: '#6E615E', marginBottom: '3rem' }}>
            A serious marriage consultation platform — not a dating website.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(270px, 1fr))',
          gap: '1.8rem',
          marginBottom: '4rem'
        }}>
          {STEPS.map((s) => (
            <div key={s.step} className="card" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                  <span style={{ fontSize: '2.5rem' }}>{s.icon}</span>
                  <span className="badge-light">Step {s.step}</span>
                </div>
                <h3 style={{ fontSize: '1.35rem', fontWeight: 800, color: '#9E1B32', marginBottom: '0.5rem', fontFamily: 'var(--serif)' }}>
                  {s.title}
                </h3>
                <p style={{ fontSize: '0.86rem', color: '#6E615E', lineHeight: 1.6 }}>
                  {s.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Match Limit & Confidentiality Policy Card */}
        <div className="card" style={{
          background: 'linear-gradient(135deg, #1C1014 0%, #28171C 100%)',
          color: 'white',
          border: '1.5px solid #D4AF37',
          marginBottom: '4rem',
          textAlign: 'center'
        }}>
          <span className="badge" style={{ background: 'rgba(212, 175, 55, 0.25)', color: '#F7D070', marginBottom: '0.8rem' }}>
            🔒 Free Registration & Matchmaking Policy
          </span>
          <h2 style={{ fontFamily: 'var(--serif)', fontSize: '2.2rem', fontWeight: 700, color: '#F7D070', margin: '0.5rem 0' }}>
            Personal Matchmaking by Laxmikant Timilsina
          </h2>
          <p style={{ fontSize: '0.92rem', color: 'rgba(255,255,255,0.88)', maxWidth: '780px', margin: '0 auto 1.6rem', lineHeight: 1.7 }}>
            Registration is <strong>100% Free</strong>. Upon completing profile submission, users are assigned <strong>confidential, curated match recommendations</strong>. All phone numbers and personal identities remain protected until mutually accepted.
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button className="btn btn-secondary" onClick={() => navigate('/consultation/register')}>
              Free Profile Registration →
            </button>
            <a href="tel:9857074103" className="btn btn-tertiary">
              📞 Call Laxmikant (9857074103)
            </a>
          </div>
        </div>

        {/* Sabitri Catering & Tent House Integration Card */}
        <div style={{ marginBottom: '1rem' }}>
          <h2 className="section-title">Wedding Feast & Event Services Partner</h2>
          <p style={{ textAlign: 'center', color: '#6E615E', marginBottom: '3rem' }}>
            When couples decide to marry, Sabitri Catering & Tent House handles your wedding celebration.
          </p>
        </div>

        <div className="card" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', alignItems: 'center', marginBottom: '4rem' }}>
          <div>
            <span className="badge-light">🍽️ Wedding Catering & Decor Partner</span>
            <h3 style={{ fontSize: '1.8rem', fontWeight: 700, color: '#9E1B32', margin: '0.6rem 0 0.3rem', fontFamily: 'var(--serif)' }}>
              Sabitri Catering and Tent House
            </h3>
            <div style={{ fontSize: '0.88rem', fontWeight: 700, color: '#8C6A23', marginBottom: '0.8rem' }}>
              Managing Director: Krishna Khanal (Contact: 9867155395)
            </div>
            <p style={{ fontSize: '0.88rem', color: '#6E615E', lineHeight: 1.65, marginBottom: '1.4rem' }}>
              Providing authentic Palpali Bhoj, Newari Samay Baji feasts, Royal Indian Banquets, marquee tents, and Palpali floral mandap decor for your wedding ceremony.
            </p>
            <button className="btn btn-primary" onClick={() => navigate('/catering')}>
              Explore Sabitri Catering & Mandap Decor →
            </button>
          </div>

          <div style={{ background: '#FAF6ED', padding: '1.8rem', borderRadius: '16px', border: '1px solid #E8DFD1' }}>
            <h4 style={{ fontWeight: 800, color: '#1C1014', marginBottom: '0.8rem' }}>📍 Official Business Location</h4>
            <div style={{ fontSize: '0.86rem', color: '#6E615E', lineHeight: 1.8 }}>
              🏢 <strong>Main Office:</strong> Yogikuti, Butwal, Nepal<br />
              💍 <strong>Matrimonial Director:</strong> Laxmikant Timilsina (9857074103)<br />
              🍽️ <strong>Catering & Decor Manager:</strong> Krishna Khanal (9867155395)<br />
              💻 <strong>Technical Support:</strong> Prakash Sharma Timilsina (<a href="https://pourkas.org" target="_blank" rel="noopener noreferrer" style={{ color: '#9E1B32', fontWeight: 700, textDecoration: 'underline' }}>pourkas.org</a>)
            </div>
          </div>
        </div>

    </div>
  );
}
